import { User } from './user';

export interface OrderLogUser extends User {
  blockedBy: string;
}
